import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Statistics_API } from "../../../APIs/statistics.api";
import { STATE_LOADING } from "../../../Constants";
import { LoadingIcon } from "../../../Icons/loading.icon";
import { IsDate } from "../../../utils/isDate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRetweet } from "@fortawesome/free-solid-svg-icons";
export const TableChart = ({
  props,
  criteria,
  chart_id,
  extraButtons,
  handleRefreshPage,
}) => {
  const {
    api: { url },
    params,
  } = props;
  const [data, setData] = useState([]);
  const [isFetching, setIsFetching] = useState(STATE_LOADING.PENDING);
  const { post } = Statistics_API;
  const [field, setField] = useState({});
  const {
    lang,
    proxy,
    auth,
    functions: { renderData },
  } = useSelector((state) => state);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 15;

  const indexOfLastData = currentPage * rowsPerPage;
  const indexOfFirstData = indexOfLastData - rowsPerPage;
  const currentData =
    data && data.length > 0 && data?.slice(indexOfFirstData, indexOfLastData);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const totalPages = Math.ceil(
    data && data.length > 0 && data.length / rowsPerPage
  );

  const handleFetchStatisticAPI = async (criteria) => {
    try {
      const res = await post(url, proxy(), criteria);
      let { data } = res;

      setIsFetching(STATE_LOADING.SUCCESS);
      const mapped_data = [];
      setData(data);
    } catch (e) {
      console.log("ERROR OF FETCHING API AT TABLE CHART", e);
      setIsFetching(STATE_LOADING.FAILED);
    }
  };

  function handleRenderData(input, default_value = 0) {
    if (!input) {
      return default_value;
    }

    if (IsDate(input)) {
      return new Date(input).toLocaleString();
    }

    // if (!isNaN(input)) {
    //   input = new Intl.NumberFormat("vn-VN").format(input);
    //   return input;
    // }
    return input;
  }

  useEffect(() => {
    if (criteria?.charts?.includes(chart_id)) {
      handleFetchStatisticAPI(criteria.data);
    }
  }, [criteria]);

  useEffect(() => {
    handleFetchStatisticAPI();
  }, [url]);

  if (isFetching === STATE_LOADING.PENDING) {
    return (
      <img
        width={40}
        className="loading-image"
        src="/images/icon/load.gif"
        alt="Loading..."
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 2,
        }}
      />
    );
  } else if (isFetching === STATE_LOADING.FAILED) {
    return <p class="text-center font-weight-bold">{lang["not found"]}</p>;
  }

  return (
    <section>
      <div
        class="table-responsive table-custom"
        style={{ padding: "6px 12px" }}
      >
        <div className="d-flex justify-content-end align-items-center title mb-2">
          {props?.content ? (
            <div style={{ fontStyle: "bold", ...props.style, padding: "0px" }}>
              <h5>{props.content}</h5>
            </div>
          ) : (
            field &&
            field.length > 0 && (
              <div style={{ fontStyle: "bold", ...props.props.style }}>
                <h5>{field?.[0].field_name}</h5>
              </div>
            )
          )}
          <FontAwesomeIcon
            icon={faRetweet}
            onClick={handleRefreshPage}
            className="icon-add pointer mr-3"
            title={lang["Refresh"]}
            style={{ fontSize: "27px", color: "#e0762a" }}
          />
          {extraButtons?.props?.buttons?.export?.state === true && (
            <>{extraButtons}</>
          )}
        </div>

        <div style={{ overflow: "auto" }}>
          <div style={{ overflowX: "auto" }}>
            <table class="table table-hover">
              <thead>
                {props?.source?.DisplayFields?.length > 0 ? (
                  <>
                    <tr>
                      <td scope="col" style={{ padding: "10px" }}>
                        #
                      </td>
                      {props?.source?.DisplayFields.map(
                        ({ label: value }, i) => (
                          <td scope="col" style={{ padding: "10px" }} key={i}>
                            {value}
                          </td>
                        )
                      )}
                    </tr>
                  </>
                ) : null}
              </thead>
              <tbody className="b-0">
                {currentData && currentData.length > 0 ? (
                  currentData.map((item, idx) => {
                    if (!Object.values(item).length) return null;

                    const cells = (props?.source?.DisplayFields ?? []).map(
                      ({ value }, fieldIndex) => {
                        const vals = (value ?? []).map(({ value: v }) =>
                          handleRenderData(item?.[v])
                        );

                        return (
                          <td key={fieldIndex}>
                            {vals.map((val, i) => (
                              <p key={i}>{val}</p>
                            ))}
                          </td>
                        );
                      }
                    );

                    return (
                      <tr key={idx}>
                        <td className="cell" scope="row">
                          {indexOfFirstData + idx + 1}
                        </td>
                        {cells}
                      </tr>
                    );
                  })
                ) : (
                  <tr style={{ textAlign: "center" }}>
                    <td colSpan={50}>{lang["not found data"]}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {currentData && currentData.length > 0 && (
            <div className="d-flex justify-content-between align-items-center mt-2 mb-2">
              <p>
                {lang["show"]} {indexOfFirstData + 1}-
                {Math.min(indexOfLastData, data.length)} {lang["of"]}{" "}
                {data.length} {lang["results"]}
              </p>
              <nav aria-label="Page navigation example">
                <ul className="pagination mb-0">
                  {/* Nút đến trang đầu */}
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <button className="page-link" onClick={() => paginate(1)}>
                      &#8810;
                    </button>
                  </li>
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => paginate(Math.max(1, currentPage - 1))}
                    >
                      &laquo;
                    </button>
                  </li>
                  {currentPage > 2 && (
                    <li className="page-item">
                      <span className="page-link">...</span>
                    </li>
                  )}
                  {Array(totalPages)
                    .fill()
                    .map((_, index) => {
                      if (
                        index + 1 === currentPage ||
                        (index + 1 >= currentPage - 1 &&
                          index + 1 <= currentPage + 1)
                      ) {
                        return (
                          <li
                            key={index}
                            className={`page-item ${
                              currentPage === index + 1 ? "active" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => paginate(index + 1)}
                            >
                              {index + 1}
                            </button>
                          </li>
                        );
                      }
                      return null;
                    })}
                  {currentPage < totalPages - 1 && (
                    <li className="page-item">
                      <span className="page-link">...</span>
                    </li>
                  )}
                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() =>
                        paginate(Math.min(totalPages, currentPage + 1))
                      }
                    >
                      &raquo;
                    </button>
                  </li>
                  {/* Nút đến trang cuối */}
                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => paginate(totalPages)}
                    >
                      &#8811;
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
